@if (isMobile() && isExpanded()) {
  <button
    (click)="toggle()"
    aria-label="Close basket"
    class="basket-sticky-wrapper__overlay"
    type="button"
  ></button>
}

<div
  [class.basket-sticky-wrapper__shell--expanded]="isMobile() && isExpanded()"
  [class.basket-sticky-wrapper__shell--mobile]="isMobile()"
  class="basket-sticky-wrapper__shell"
>
  <ng-content />
</div>
